/* Night Flow presell (theme version): countdown in the offer box and the quote carousel arrows.
   Re-initialises a section when the theme editor re-renders it. */
(function () {
  'use strict';
  function initCountdown(el) {
    if (el.getAttribute('data-nf-init')) return;
    el.setAttribute('data-nf-init', '1');
    var m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    if (!m || !s) return;
    var t = (Number(el.getAttribute('data-minutes')) || 10) * 60 - 1;
    function tick() {
      var mm = Math.floor(t / 60), ss = t % 60;
      m.textContent = String(mm).padStart(2, '0'); s.textContent = String(ss).padStart(2, '0');
      if (t > 0 && document.body.contains(el)) { t--; setTimeout(tick, 1000); }
    }
    tick();
  }
  function initCarousel(el) {
    if (el.getAttribute('data-nf-init')) return;
    el.setAttribute('data-nf-init', '1');
    var c = el.querySelector('.cards');
    if (!c) return;
    var btns = el.querySelectorAll('.car-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var w = c.firstElementChild ? c.firstElementChild.getBoundingClientRect().width + 16 : 342;
        c.scrollBy({ left: w * Number(this.getAttribute('data-dir')), behavior: 'smooth' });
      });
    }
  }
  function init(scope) {
    var root = scope || document;
    var cds = root.querySelectorAll('.countdown'); for (var i = 0; i < cds.length; i++) initCountdown(cds[i]);
    var cars = root.querySelectorAll('.carousel'); for (var j = 0; j < cars.length; j++) initCarousel(cars[j]);
  }
  init();
  if (window.Shopify && window.Shopify.designMode) document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
